import StdForm from '@shared/components/forms/auto-form/std-form/std-form.vue';
import { Component } from 'vue-property-decorator';
import EntityTableProvider from '@shared/components/tables/entity-table-provider/entity-table-provider.vue';
import EntityTable from '@shared/components/tables/entity-table/entity-table.vue';
import BpcPageTitle from '@shared/layouts/components/page-title/page-title.vue';
import { faSync } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import EntityDeleteModalProvider from '@shared/components/modals/entity-delete-modal-provider/entity-delete-modal-provider.vue';
import ConfirmationModal from '@shared/components/modals/confirmation-modal/confirmation-modal.vue';
import { ValidationObserver } from 'vee-validate';
import { Profile } from '@core/interfaces/profile';
import { mixins } from 'vue-class-component';
import AbstractTable from '@shared/components/tables/abstract-table/abstract-table';
import StdFilter from '@shared/components/filters/std-filter/std-filter.vue';
import { User } from '@auth/interfaces/user';

library.add(faSync);

@Component({
  name: 'bpc-profile-table',
  components: {
    'bpc-entity-table-provider': EntityTableProvider,
    'bpc-entity-table': EntityTable,
    'bpc-page-title': BpcPageTitle,
    'font-awesome-icon': FontAwesomeIcon,
    'bpc-entity-delete-modal-provider': EntityDeleteModalProvider,
    'bpc-confirmation-modal': ConfirmationModal,
    'bpc-std-form': StdForm,
    'bpc-std-filter': StdFilter,
    ValidationObserver,
  },
})

// TODO: do not extend from abstract table, extract the form logic in a new mixin
export default class EditPassword extends mixins(AbstractTable) {
  public entity: User = null;
  public entityName = 'user';
  public pluralEntityName = 'users';

  get savePath(): string {
    return `/auth/update-password`;
  }

  constructor() {
    super();
  }

  /* Lifecycle hooks */

  // created() { }
  // mounted() {}
  // updated () { }
  // destroyed () { }
}
